export default (commonBasicPlanCheckout) =>
  ({ 
    planSelectionPath, 
    paymentsPath, 
    isTrackVisitCheckout, 
    isAbandonedBasket,
    isCheckPrivacyAgreement
  } = {}) => ({
    // Init basic common checkout functionality

    ...commonBasicPlanCheckout({
      planSelectionPath,
      paymentsPath,
      isTrackVisitCheckout,
      isAbandonedBasket,
    }),

    privacyAgreementError: false,

    init() {
      this.commonInit()

      this.privacyAgreementError = false
    },

    submitOffer() {
      if (isCheckPrivacyAgreement && !this.store.values.privacyAgreement) {
        this.privacyAgreementError = true

        this.store.internalTracker.trackClick({ clickName: "Get Plan Blocked By Policy" })
        return
      }
      this.store.internalTracker.setEventToSessionStorage({ clickName: "Get Plan Clicked" })

      this.commonSubmitOffer()
    },
  })
